import { useTranslation } from 'react-i18next';
import { Skeleton } from '../../../components/ui/skeleton';

// One block per column of the listing, each sized like the value it stands for: the table keeps
// its shape while it loads, so nothing jumps when the rows land. Widths follow getIssuesColumns —
// key, summary, status, type, store, reporter, assignee, created, updated, actions.
const CELLS = [
  'w-[68px]',
  'flex-1 min-w-[90px]',
  'w-[86px] rounded-full',
  'w-[76px]',
  'w-[104px]',
  'w-[88px]',
  'w-[84px]',
  'w-[64px]',
  'w-[64px]',
  'w-[28px]',
];

const ROWS = [0, 1, 2, 3, 4, 5, 6, 7];

// The shared primitive is `bg-gray-200`, with no dark variant of its own.
const BLOCK = 'dark:bg-gray-700';

export const IssuesTableSkeleton = () => {
  const { t } = useTranslation();

  return (
    <div role="status">
      <div className="flex items-center gap-[18px] border-b px-5 py-[13px]">
        {CELLS.map((width, cell) => (
          <Skeleton key={cell} className={`h-3 ${BLOCK} ${width}`} />
        ))}
      </div>

      {ROWS.map((row) => (
        <div
          key={row}
          className="flex items-center gap-[18px] border-b px-5 py-[15px] last:border-b-0"
        >
          {CELLS.map((width, cell) => (
            <Skeleton key={cell} className={`h-4 ${BLOCK} ${width}`} />
          ))}
        </div>
      ))}

      {/* The blocks say nothing to a screen reader; this does. */}
      <span className="sr-only">{t('Loading…')}</span>
    </div>
  );
};
